import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'LeagueSeasonPlayer';

const LeagueSeasonPlayerApi: any = baseApi(endpoint);

export default LeagueSeasonPlayerApi;